const SUCCESS_BS_REDIRECT_PREFIX = "sbs_redirect";

export const SUCCESS_BS_REDIRECT_TEST_IDS = {
    TITLE: `${SUCCESS_BS_REDIRECT_PREFIX}_title`,
    TIMER_TEXT: `${SUCCESS_BS_REDIRECT_PREFIX}_timer_text`,
};
